'use client';

import { createContext, PropsWithChildren, useContext, useId } from 'react';

type InputContextData = {
  id: string;
};

const InputContext = createContext({} as InputContextData);

export type InputContextProviderProps = PropsWithChildren;

export function InputContextProvider({ children }: InputContextProviderProps) {
  const id = useId();

  return (
    <InputContext.Provider value={{ id }}>{children}</InputContext.Provider>
  );
}

export function useInputContext() {
  const context = useContext(InputContext);

  if (!context) {
    throw new Error(
      'useInputContext must be used within a InputContextProvider',
    );
  }

  return context;
}
